import request from '@/utils/http';
import { otpBaseUrl } from './baseUrl';

// 获取地址覆盖范围列表
export const getScPosConfig = (params) => {
    return request({
        url: `${otpBaseUrl}/scPosConfigs`,
        method: 'get',
        params
    });
};

// 商超标识批量新增或者保存
export const saveScPosConfig = (data) => {
    return request({
        url: `${otpBaseUrl}/scPosConfig/batchCreateOrUpdate`,
        method: 'post',
        data
    });
};

// 根据ID批量删除商超标识
export const delScPosConfig = (data) => {
    return request({
        url: `${otpBaseUrl}/scPosConfig/batchDeleteByBusinessKey`,
        method: 'DELETE',
        data
    });
};
